import axios from "axios";
import * as localforage from "localforage";
import { url } from "./apiSetup";
import { errorHandling } from "../helpers/errorHandling";
import PlatFormLoading from "@/components/loading"; // 公共进度条

export const phpRequest = axios.create({
  // baseURL: `${url}/api/v1`
});

let timer;
const origHttpGet = phpRequest.get;
const origHttpDelete = phpRequest.delete;

// 全局loading
let requestCount = 0;
const showLoading = () => {
  if (requestCount <= 0) {
    PlatFormLoading.show();
  }
  requestCount++;
};

const hideLoading = () => {
  try {
    requestCount--;
    if (requestCount <= 0) {
      PlatFormLoading.hide();
    }
  } catch (e) {
    console.log(e);
  }
};

// 重写get方法，保持跟post方法传参一致
phpRequest.get = (url, params, config) => {
  return origHttpGet(url, { params, ...config });
};

// 重写delete方法，保持跟post方法传参一致
phpRequest.delete = (url, params, config) => {
  return origHttpDelete(url, { params, ...config });
};

phpRequest.interceptors.request.use(
  async config => {
    if (config.showLoading) {
      showLoading();
    }
    const token = await localforage.getItem("token");
    const lang = localStorage.getItem("rcml-lang");
    config.baseURL = `${url}/api/v1`;
    config.headers.Accept = "application/json";
    config.headers.Authorization = "Bearer " + token;
    config.headers.AcceptLanguage = lang || "en";
    return config;
  },
  error => {
    PlatFormLoading.hide();
    return Promise.reject(error);
  }
);

phpRequest.interceptors.response.use(
  response => {
    if (response.config.showLoading) {
      hideLoading();
    }
    return response.data;
  },
  err => {
    hideLoading();
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    if (!err.response) {
      return Promise.reject(err);
    }
    timer = setTimeout(() => {
      if (err.name === "CanceledError") {
        return;
      }
      errorHandling(err);
    });

    return Promise.reject(err);
  }
);
